import React, { useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';
import { Page } from '../../hoc/Page.jsx';
import { ClientSidePaginationList } from '../../hoc/ClientSidePaginationList.jsx';
import { setLastBreadcrumbsArray, setPageHeadObject } from '../../actions/app';
import { EDUCATION_TYPE_SLUG, ARRANGEMENT_TYPE_SLUG, DEPARTMENTS } from '../../../config';

import FilterSet from '../common/Filters/FilterSet.jsx';
import Sorting from '../common/Filters/Sorting.jsx';
import { getPurchases } from '../../actions/purchases';
import { getVisiblePurchases } from '../../reducers/purchase-selector';
import PurchasesItem from './PurchasesItem.jsx';
import EducationPurchasesItem from './EducationPurchasesItem.jsx';
import PurchasesInfo from './PurchasesInfo.jsx';


const Purchases = ({ lang, isLoading, count, paginateList, list, setPageHeadObject, setLastBreadcrumbsArray }) => {
  let { type } = useParams();
  useEffect(() => {
    if (type){
      const title = DEPARTMENTS['purchases']['children'][type]['title'];
      setPageHeadObject({ title });
      setLastBreadcrumbsArray({ title, url: `/${type}/` });
    }
  }, []);

  let items;
  if (!isLoading) {
    if (count){
      items = paginateList.map(item => {
        if (item.offer_type === EDUCATION_TYPE_SLUG){
          return <EducationPurchasesItem key={item.id} {...item}/>
        } else {
          return <PurchasesItem key={item.id} {...item}/>
        }
      });
    } else {
      items = <p>{ gettext('Ничего не найдено.') }</p>;
    }
  }

  return <div>
    { !type && <PurchasesInfo/> }
    { (type && type !== EDUCATION_TYPE_SLUG) && <p className='text-right'>
      <Button href={`/${lang}/my/download-zip/${type}/`} variant='primary' size='sm'>
        <i className='icon icon-floppy'></i>{ gettext('Скачать всё') }
      </Button>
    </p> }

    <FilterSet isLoading={ isLoading }
               difficultyFilter={ (type && type !== EDUCATION_TYPE_SLUG) }
               tonalityFilter={ (type && type === ARRANGEMENT_TYPE_SLUG) }
               typeFilter={ !type }
               showEducation={ true }
               authorFilter={ true }
               list={ list }
               colSize={ type === ARRANGEMENT_TYPE_SLUG ? 4 : 6 }/>
    { count > 0 && <Sorting fields={ ['id', 'title'] }/> }
    { items }
  </div>
}

Purchases.propTypes = {
  lang: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  setPageHeadObject: PropTypes.func.isRequired,
  setLastBreadcrumbsArray: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  paginateList: PropTypes.array.isRequired,
}

let mapStateToProps = (state) => {
  return {
    lang: state.auth.lang,
    list: getVisiblePurchases(state),
  }
};

export default compose(
  connect(mapStateToProps, { loadListFromServer: getPurchases, setLastBreadcrumbsArray, setPageHeadObject }),
  LoginRequired,
  Page,
  ClientSidePaginationList
)(Purchases)

